/**
 * UI routes for the production auto-scheduling data foundation.
 *
 * These are intentionally distinct from the existing `/auto-scheduling`
 * aliases, which remain assigned to personnel-scheduling solver routes.
 */
export const PRODUCTION_AUTO_SCHEDULING_ROOT = '/production-auto-scheduling';

export const PRODUCTION_AUTO_SCHEDULING_ROUTES = {
  root: PRODUCTION_AUTO_SCHEDULING_ROOT,
  cipTopology: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/cip-topology`,
  cipLoops: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/cip-loops`,
  equipmentStateModel: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/equipment-state-model`,
  facilityMaster: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/facility-master`,
  processTemplates: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/process-templates`,
  processTemplateContract: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/process-template-contract`,
  worldState: `${PRODUCTION_AUTO_SCHEDULING_ROOT}/world-state`,
} as const;

export const PRODUCTION_AUTO_SCHEDULING_DEFAULT_ROUTE = PRODUCTION_AUTO_SCHEDULING_ROUTES.cipTopology;

/** Legacy browser URLs that must continue to resolve after the navigation split. */
export const PRODUCTION_AUTO_SCHEDULING_LEGACY_REDIRECTS: Record<string, string> = {
  '/prod/cip-topology': PRODUCTION_AUTO_SCHEDULING_ROUTES.cipTopology,
  '/prod/equipment-state-model': PRODUCTION_AUTO_SCHEDULING_ROUTES.equipmentStateModel,
  '/equipment-state-machine': PRODUCTION_AUTO_SCHEDULING_ROUTES.equipmentStateModel,
  '/prod/facility-master': PRODUCTION_AUTO_SCHEDULING_ROUTES.facilityMaster,
  '/prod/process-templates': PRODUCTION_AUTO_SCHEDULING_ROUTES.processTemplates,
  '/prod/process-template-contract': PRODUCTION_AUTO_SCHEDULING_ROUTES.processTemplateContract,
  '/prod/world-state': PRODUCTION_AUTO_SCHEDULING_ROUTES.worldState,
};
